import { useState } from "react";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { Form, InputGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const PasswordInput = ({
  customHeading,
  value = "",
  onChange = () => {},
  placeholder = "Your Password",
  name,
  required = false,
  errors,
  type = "",
}) => {
  const [isShowPassword, setIsShowPassword] = useState(true);

  const handleShowPassword = () => {
    setIsShowPassword((prev) => !prev);
  };

  return (
    <Form.Group className="mb-3" controlId="username">
      <Form.Label className="required">
       {customHeading}
        {type === "login" && (
          <span className="form-label-description">
            <NavLink to="/forgot-password">Forgot Password</NavLink>
          </span>
        )}
      </Form.Label>
      <InputGroup>
        <Form.Control
          type={isShowPassword ? "password" : "text"}
          placeholder={placeholder}
          name={name}
          required={required}
          isInvalid={!!errors}
          value={value}
          onChange={onChange}
          autoComplete="off"
        />
        <InputGroup.Text>
          {isShowPassword ? (
            <IconEyeOff stroke={1}
              className="link-secondary"
              onClick={handleShowPassword}
            />
          ) : (
            <IconEye className="link-secondary" onClick={handleShowPassword} />
          )}
        </InputGroup.Text>
        <Form.Control.Feedback type="invalid">
          {errors || "Please enter password."}
        </Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
};

export default PasswordInput;
